import cn from "classnames";
import type { ComponentProps } from "react";
import styles from "./ButtonLink.module.css";

export function ButtonLink(props: ComponentProps<"button">) {
  const { className, ...rest } = props;

  return <button className={cn(styles.buttonLink, className)} {...rest} />;
}
